import timezone from "dayjs/plugin/timezone";
import { useAuth } from "../../../../public/auth/infrastructure/store/auth-context";
import { useCallback } from "react";
import utc from "dayjs/plugin/utc";
import dayjs, { Dayjs } from "dayjs";

export const useUTCDate = (): {
  currentDate: () => Dayjs;
  dateFromUTC: (date: Date | string) => Dayjs;
} => {
  const { user } = useAuth();
  dayjs.extend(utc);
  dayjs.extend(timezone);

  const { timezone: tz } = user ?? {};

  const currentDate = useCallback(
    (): Dayjs =>
      tz?.timezone
        ? dayjs().utc().utcOffset(dayjs().tz(tz.timezone).utcOffset())
        : dayjs(),
    [tz?.timezone]
  );

  const dateFromUTC = useCallback(
    (date: Date | string): Dayjs => {
      return tz?.timezone
        ? dayjs.utc(date).utcOffset(dayjs(date).tz(tz.timezone).utcOffset())
        : dayjs(date);
    },
    [tz?.timezone]
  );

  return { currentDate, dateFromUTC };
};
